module.exports = __webpack_public_path__ + "img/01_zhCn.8e18ee5a.png";